import { z } from 'zod';

const ORDER_BY_OPTIONS = [
  'created_at:asc', 'created_at:desc',
  'power:asc', 'power:desc',
] as const;

export const batteryFiltersSchema = z.object({
  brand: z.string().optional(),
  is_enabled: z.boolean().optional(),
  model: z.string().optional(),
  order_by: z.enum(ORDER_BY_OPTIONS).optional(),
  sku: z.string().optional(),
});

export type BatteryFiltersFormData = z.infer<typeof batteryFiltersSchema>;
